import { Injector, Pipe, PipeTransform } from '@angular/core';
import * as moment from "@node_modules/moment";

@Pipe({
    name: 'dayName'
})
export class DayNamePipe implements PipeTransform {

    constructor() {}

    transform(feature: moment.Moment): string {
        return feature.format('dddd');
    }
}
